import { useEffect, useState } from 'react';
import { authService } from '../services/auth';

export function useIsLoggedIn(): boolean {
    const [isLoggedIn, setIsLoggedIn] = useState(() => authService.hasToken());

    useEffect(() => {
        if (!authService.hasToken()) {
            setIsLoggedIn(false);
            return;
        }

        let isMounted = true;

        authService.verify().then((isVerified) => {
            if (isMounted) {
                setIsLoggedIn(isVerified);
            }
        });

        return () => {
            isMounted = false;
        };
    }, []);

    return isLoggedIn;
}
